import Snackbar from 'node-snackbar';
import JSR from 'mm-jsr';
import 'core-js/modules/es.array.flat'; // For JSR range slider

import { hideLoader, showLoader } from '../../globalFunctions';
import { parseHTML } from '../../utils/parseHTML';
import { setUrlParameter } from '../../utils/setUrlParameter';
import { arrayUnique } from '../../utils/arrayUnique';
import { logError } from '../../utils/logError';
import { prkCollapsibleConfigs } from '../../prk/prk-collapsible/handlers';
import { loadJQuery } from '../../async/loadJQuery.js';
import { loadPrkCollapsible } from '../../async/loadPrkCollapsible.js';
import { prkModalConfigs } from '../hashed-links-handlers';
import URLQueryParams from '../../url-query-params';
import { toggleHierarchicalTermsFilterState } from './toggleHierarchicalTermsFilterState';
import { toggleTermsFilterState } from './toggleTermsFilterState';
import escapeHTML from '../../utils/escapeHTML';

const MAIN_SEPARATOR = '-is-';
const VALUES_SEPARATOR = '-or-';
const FILTER_PARAM_NAME = 'prk_f';
const FILTER_PARAM_SEPARATOR = '|';
const FILTER_PARAM_VALUE_CONNECTOR = '~';

const JS_HIERARCHICAL_TERMS_FILTER_CLASS = 'js-hierarchical-terms-filter';

// Global storage for numeric filter JS-range controls and respective properties
window.prkRangeFiltersMap = window.prkRangeFiltersMap || new Map();
window.prkAdditionalFiltersMap = window.prkAdditionalFiltersMap || {};
let draggedSliderFilterCode = null;

prkCollapsibleConfigs['terms'] = {
    onBeforeCollapse: async function (next) {
        const showMoreCollapsibleElement = this.element.querySelector('.show-more-collapsible');
        if (showMoreCollapsibleElement) {
            const PrkCollapsible = await loadPrkCollapsible();
            const showMoreCollapsible = new PrkCollapsible(showMoreCollapsibleElement, prkCollapsibleConfigs['terms-show-more']);
            if (showMoreCollapsible.isExpanded)
                showMoreCollapsible.collapse();
        }
        next();
    }
};
prkCollapsibleConfigs['terms-show-more'] = {
    onBeforeExpand: async function (next) {
        const isAdditionalFiltersRenderedClass = 'is-rendered',
              isAdditionalFiltersRendered      = this.element.classList.contains(isAdditionalFiltersRenderedClass);

        if (!isAdditionalFiltersRendered) {
            const filterCode     = this.element.dataset.filterCode,
                additinalFilters = window.prkAdditionalFiltersMap[filterCode] || [];

            if (additinalFilters.length) {
                this.content.innerHTML = additinalFilters.map(filter => {
                    const showLink = filter.showLink;
                    return `
                        <div class="cool-checkbox js-FilterCheckbox${filter.filteredCount === 0 ? ' inactive' : ''}" title="${filter.title}">
                            <${showLink ? 'a href="' + prepareFilterUrl(filter) + '"' : 'span'}>
                                <input type="checkbox" value="${filter.value}" data-seo-value="${filter.seoValue}" ${filter.checked ? 'checked' : ''}>
                                <span class="checkmark"></span>
                                <span>${filter.title}</span>
                                <span class="count">${filter.filteredCount}</span>
                            </${showLink ? 'a' : 'span'}>
                        </div>
                    `;
                }).join('');
            }

            this.element.classList.add(isAdditionalFiltersRenderedClass);
        }

        this.header.style.display = 'none';
        next();
    },
    onCollapsed: function () {
        this.header.style.display = '';
    }
};

// Init catalog filters
export function initCatalogFilters() {
    // Init numeric filters
    initNumericFilters();

    // Init terms filters
    initTermsFilters();

    initSelectedFilters();
}

export function initSortAndPaging() {
    $(document).on('click', '.js-query-string-link', changeQueryStringHandler);
}

export function initSelectedFilters() {
    // Add "Remove filter" handlers
    $(document).on('click', '.js-selectedFiltersBlock li .pi-close', function () {
        const filterCode = $(this).data('code');
        const filterSeoValue = $(this).data('seo-value');
        removeGlobalFilter(filterCode, filterSeoValue);

        if (typeof filterSeoValue !== 'undefined') {
            const filterValue = $(this).data('value');
            const filterViewValue = $(this).data('view-value');

            window.prkSelectedFilters.forEach(function (filter) {
                if (filter.code === filterCode) {
                    const newFilterValues = filter.values.filter(e => e !== filterValue);
                    const newFilterViewValues = filter.viewValues.filter(e => e !== filterViewValue);
                    const newFilterSeoValues = filter.seoValues.filter(e => e !== filterSeoValue);

                    onTermsFilterChange(filterCode, filter.label, filter.seoCode, newFilterValues, newFilterViewValues, newFilterSeoValues);
                }
            });
        } else {
            // Re-render selected filters block
            renderSelectedFiltersBlock();
            // Update result products
            updateResultProductList();
        }
    });
    // Add "Clear all filters" handler
    $(document).on('click', '.js-removeAllFilters', function () {
        removeAllFilters();
    });
}

export function initCatalogFiltersModal() {
    // Add mobile filters popup config
    prkModalConfigs['prk_filters_modal'] = {
        onOpen: async function() {
            if (this.modal.classList.contains('loaded'))
                return;

            try {
                const error = this.modal.querySelector('div.error');
                if (error) error.remove();
                initCatalogFilters();
                this.modal.classList.add('loaded');
            } catch (error) {
                logError(error);
                this.modal.append(...parseHTML('<div class="error">Ошибка, попробуйте позже</div>'));
            }
        }
    }
}

/**
 * This EventListener has to be attached to document directly
 * because if user releases a slider outside of slider,
 * the event also happens outside.
 * That is why @var draggedSliderFilterCode is used to know
 * what slider was dragged
 */
function onSliderIsReleased() {
    $(document).off('mouseup touchend', onSliderIsReleased);
    const filter = window.prkRangeFiltersMap.get(draggedSliderFilterCode);
    draggedSliderFilterCode = null;

    // Just for safety
    if (!filter)
        return;

    // Call onChange event only when a value has really changed
    if (filter.hasValueChanged)
        onNumericFilterChange(filter.filterCode, [filter.jsr.getRealValue(0), filter.jsr.getRealValue(1)]);

    filter.hasValueChanged = false;
    filter.isSliderDragged = false;
}

function initNumericFilters() {
    for (const numericFilter of [...document.querySelectorAll('.js-numericFilter')]) {
        initNumericFilter(numericFilter);
    }

    // Add inputs onChange listeners
    $(document).on('change', '.js-filterMin, .js-filterMax', function() {
        const numericFilterContainer = $(this).closest('.js-numericFilter')[0];
        const filterCode = numericFilterContainer.dataset.code;
        const filter = window.prkRangeFiltersMap.get(filterCode);
        if (!filter)
            return;

        const { minValue, maxValue, minValueInput, maxValueInput } = filter;
        const notNumberPattern = /[^0-9\.]/g;

        let currentMinValue = Number(minValueInput.value.replace(notNumberPattern, ''));
        let currentMaxValue = Number(maxValueInput.value.replace(notNumberPattern, ''));

        // Limit checks
        if (currentMinValue < minValue || currentMinValue > currentMaxValue)
            currentMinValue = minValue;
        if (currentMaxValue > maxValue)
            currentMaxValue = maxValue;

        const newRange = [currentMinValue, currentMaxValue];
        onNumericFilterChange(filterCode, newRange);
    });

    // Prevent sending api requests on value change while slider is being dragged
    $(document).on('mousedown touchstart', '.jsr_slider', function() {
        const numericFilterContainer = $(this).closest('.js-numericFilter')[0];
        const filterCode = numericFilterContainer.dataset.code;
        const filter = window.prkRangeFiltersMap.get(filterCode);
        filter.isSliderDragged = true;

        draggedSliderFilterCode = filterCode;
        $(document).on('mouseup touchend', onSliderIsReleased);
    });
}

/**
 * @param {HTMLElement} container
 */
function initNumericFilter(container) {
    const minValue = Number(container.dataset.minValue);
    const maxValue = Number(container.dataset.maxValue);
    const minValueInput = container.querySelector('.js-filterMin');
    const maxValueInput = container.querySelector('.js-filterMax');
    const selectedMinValue = Number(minValueInput.value);
    const selectedMaxValue = Number(maxValueInput.value);

    // Stop unless data is correct
    if (Number.isNaN(minValue) || Number.isNaN(maxValue) || maxValue <= minValue)
        return;

    // Init Slider
    const filterCode = container.dataset.code;
    const label = container.dataset.label;
    const suffix = label.split(',')[1] ?? '';
    const sliderInput = container.querySelector('.js-rangeSlider');
    const jsr = new JSR({
        modules: [
            new JSR.Rail(),
            new JSR.Slider(),
            new JSR.Bar(),
            new JSR.Label({formatter: v => `${v}${suffix}`}),
            new JSR.Grid({formatter: v => `${v}${suffix}`, getLinesCount: v => 20}),
        ],
        config: {
            min: minValue,
            max: maxValue,
            step: 1,
            initialValues: [selectedMinValue, selectedMaxValue],
            container: sliderInput,
        }
    });

    jsr.onValueChange(function () {
        // Plan value change event after slider is released
        const filter = window.prkRangeFiltersMap.get(filterCode);
        if (filter.isSliderDragged)
            filter.hasValueChanged = true;
    });

    window.prkRangeFiltersMap.set(filterCode, {
        jsr,
        minValue,
        maxValue,
        container,
        filterCode,
        label,
        minValueInput,
        maxValueInput,
        sliderInput,
        isSliderDragged: false,
        hasValueChanged: false,
    });
}

function initTermsFilters() {
    // Ignore filter link clicks
    $(document).on('click', '.js-FilterCheckbox a', event => event.preventDefault());

    // Add onChange listener
    $(document).on('click', '.js-FilterCheckbox', function(event) {
        // Don't follow link
        event.preventDefault();

        const $jsFilterCheckbox = $(this);
        const $checkboxInput = $jsFilterCheckbox.find('input[type=checkbox]');

        // Do nothing on disabled unchecked filters click
        if ($jsFilterCheckbox.hasClass('inactive') && !$checkboxInput.is(':checked')) {
            return;
        }

        // Toogle checkbox input and get all affected checkboxes
        const allAffectedCheckboxInputs = $jsFilterCheckbox.hasClass(JS_HIERARCHICAL_TERMS_FILTER_CLASS)
            ? toggleHierarchicalTermsFilterState($checkboxInput[0])
            : toggleTermsFilterState($checkboxInput[0]);

        // Update prkAdditionalFiltersMap
        const $termsFilterContainer = $jsFilterCheckbox.closest('.js-termsFilter');
        const filterCode = $termsFilterContainer.data('code');
        if (filterCode in window.prkAdditionalFiltersMap) {
            allAffectedCheckboxInputs.forEach(function (checkbox) {
                const checkBoxValue = checkbox.value;
                const filters = window.prkAdditionalFiltersMap[filterCode];
                for (let i = 0; i < filters.length; i++) {
                    if (filters[i].value === checkBoxValue) {
                        filters[i].checked = checkbox.checked;
                    }
                }
            });
        }

        // Get all checked inputs inside current filter
        const [newFilterValues, newFilterViewValues, newFilterSeoValues] = getTermsFilterSelectedValues($termsFilterContainer);
        onTermsFilterChange($termsFilterContainer.data('code'), $termsFilterContainer.data('label'),
                            $termsFilterContainer.data('seo-code'), newFilterValues, newFilterViewValues, newFilterSeoValues);
    });
}

function renderSelectedFiltersBlock() {
    const selectedFiltersBlock = document.querySelector('.js-selectedFiltersBlock');
    if (!selectedFiltersBlock)
        return;

    const selectedFiltersList = selectedFiltersBlock.querySelector('ul');

    // Close selected filters block when no filters selected
    if (!window.prkSelectedFilters.length) {
        selectedFiltersList.innerHTML = '';
        selectedFiltersBlock.classList.add('collapse');
        return;
    }

    let selectedFiltersHtml = '';

    for (const filter of window.prkSelectedFilters) {
        let selectedFilterLabel = '';
        switch (filter.type) {
            case 'terms':
                const filterValues = [];
                for (let i = 0; i < filter.viewValues.length; i++) {
                    filterValues.push(
                        `<span class="filter-value">${filter.viewValues[i]} <svg class="pi pi-single pi-close" 
                            data-code="${filter.code}"
                            data-value="${filter.values[i]}"
                            data-view-value="${filter.viewValues[i]}"
                            data-seo-value="${filter.seoValues[i]}"> 
                                <use xlink:href="#close"></use> 
                        </svg></span>`
                    );
                }
                selectedFilterLabel = filterValues.join(', ');
                break;

            case 'numeric':
                selectedFilterLabel = `от ${filter.values[0]} до ${filter.values[1]}`;
                break;
        }

        selectedFiltersHtml += `<li><svg class="pi pi-close" data-code="${filter.code}"><use xlink:href="#close"></use></svg>${filter.label}: ${selectedFilterLabel}</li>`;
    };

    // Replace ul content with new filters
    selectedFiltersList.innerHTML = selectedFiltersHtml;
    selectedFiltersBlock.classList.remove('collapse');
}

function getTermsFilterSelectedValues($termsFilterContainer) {
    const selectedValues = [];
    const selectedViewValues = [];
    const selectedSeoValues = [];
    $termsFilterContainer.find('.js-FilterCheckbox input[type=checkbox]:checked').each(filterInput => {
        const $filterOption = $(filterInput);
        selectedValues.push($filterOption.val());

        // Should escape title from attribute, because even if it is escaped in html, js returns unescaped string
        // which results in duplicated label for filters with escaped characters
        // as the value taken from window.prkAdditionalFiltersMap (code below) is escaped
        selectedViewValues.push(escapeHTML($filterOption.closest('.js-FilterCheckbox').attr('title') || ''));
        selectedSeoValues.push($filterOption.data('seo-value'));
    });

    let filterCode = $termsFilterContainer.data('code');
    if (filterCode in window.prkAdditionalFiltersMap) {
        window.prkAdditionalFiltersMap[filterCode].filter((filter) => filter.checked).forEach(filter => {
            selectedValues.push(filter.value);
            selectedViewValues.push(filter.title);
            selectedSeoValues.push(filter.seoValue);
        });
    }

    return [arrayUnique(selectedValues), arrayUnique(selectedViewValues), arrayUnique(selectedSeoValues)];
}

/**
 * @param {string} filterCode
 * @param {[number, number]} newRange
 */
function onNumericFilterChange(filterCode, newRange) {
    const filter = window.prkRangeFiltersMap.get(filterCode);
    if (!filter)
        return;

    const { minValue, maxValue, label } = filter;
    const selectedMinValue = newRange[0];
    const selectedMaxValue = newRange[1];

    // Skip same values update
    if (minValue === selectedMinValue && maxValue === selectedMaxValue) {
        const isRemoved = removeGlobalFilter(filterCode);
        if (isRemoved) {
            // Re-render selected filters block
            renderSelectedFiltersBlock();
            // Update result products
            updateResultProductList();
        }
        return;
    }

    // Refresh connected controls (slider and text inputs)
    updateNumericFilterHTML(filterCode, selectedMinValue, selectedMaxValue);

    // Prepare updated filter
    const newFilter = {
        type: 'numeric',
        label: label,
        code: filterCode,
        values: [selectedMinValue, selectedMaxValue]
    };

    // TODO: remove after refactoring search page filters
    let $currentFilterBlock = $('.js-filterBlock.js-filterPrice');
    if ($currentFilterBlock.length) {
        showResultsQuantityForFilter($currentFilterBlock);
    } else {
        // Update global filter and re-render
        addOrUpdateGlobalFilter(newFilter);
    }
}

/**
 * @param {string} filterCode
 * @param {number} minValue
 * @param {number} maxValue
 */
function updateNumericFilterHTML(filterCode, minValue, maxValue) {
    const filter = window.prkRangeFiltersMap.get(filterCode);
    if (!filter)
        return;

    const { jsr, minValueInput, maxValueInput } = filter;

    if (minValueInput.value != minValue)
        minValueInput.value = minValue;

    if (maxValueInput.value != maxValue)
        maxValueInput.value = maxValue;

    if (jsr.getRealValue(0) != minValue)
        jsr.setRealValue(0, minValue);

    if (jsr.getRealValue(1) != maxValue)
        jsr.setRealValue(1, maxValue);
}

function onTermsFilterChange(filterCode, filterLabel, filterSeoCode, newFilterValues, newFilterViewValues, newFilterSeoValues) {
    let newFilter = {
        type: 'terms',
        label: filterLabel,
        code: filterCode,
        seoCode: filterSeoCode,
        values: newFilterValues,
        viewValues: newFilterViewValues,
        seoValues: newFilterSeoValues
    };

    // Update global filter and re-render
    addOrUpdateGlobalFilter(newFilter);
}

function addOrUpdateGlobalFilter(newFilter) {
    if (newFilter.values.length > 0) {
        window.prkLastChangedFilterCode = newFilter.code;

        let isFound = false;
        window.prkSelectedFilters.forEach(function (filter) {
            if (filter.code === newFilter.code) {
                isFound = true;
                filter.values = newFilter.values;
                filter.viewValues = newFilter.viewValues;
                filter.seoValues = newFilter.seoValues;
            }
        });

        if (!isFound)
            window.prkSelectedFilters.push(newFilter);

        // Re-render selected filters block
        renderSelectedFiltersBlock();

        // Update URL and results
        updateUrl();
        updateResultProductList();
    } else {
        window.prkLastChangedFilterCode = null;

        // Remove filter if no values
        removeGlobalFilter(newFilter.code);
        // Re-render selected filters block
        renderSelectedFiltersBlock();
        // Update result products
        updateResultProductList();
    }
}

function removeGlobalFilter(filterCode, filterValue) {
    const prevFilterCount = window.prkSelectedFilters.length;

    // remove filter, if filterValue is not passed
    if (typeof filterValue === 'undefined') {
        window.prkSelectedFilters = window.prkSelectedFilters.filter(filter => filter.code !== filterCode);

        // Skip update if filter was not presented
        if (prevFilterCount === window.prkSelectedFilters.length) {
            return false;
        }
    }

    // Remove selected values from filter HTML
    clearFilterBlockSelections(filterCode, filterValue);

    // Remove filter from URL
    updateUrl();

    return true;
}

function removeAllFilters() {
    window.prkLastChangedFilterCode = null;
    window.prkSelectedFilters.forEach(function (filter) {
        removeGlobalFilter(filter.code);
    });

    // Re-render selected filters block
    renderSelectedFiltersBlock();
    // Update result products
    updateResultProductList();
}

function clearFilterBlockSelections(filterCode, filterValue) {
    const $filterContainer = $('.js-Filter[data-code="' + filterCode + '"]');
    if (!$filterContainer.length) return;

    const filterType = $filterContainer.data('type');
    if (filterType === 'numeric') {
        const filter = window.prkRangeFiltersMap.get(filterCode);
        if (!filter)
            return;

        updateNumericFilterHTML(filterCode, filter.minValue, filter.maxValue);
    } else if (filterType === 'terms') {
        if (typeof filterValue === 'undefined') {
            // Uncheck all boxes
            $filterContainer.find('.js-FilterCheckbox input[type=checkbox]')
                            .prop('checked', false);

            // Update prkAdditionalFiltersMap
            if (filterCode in window.prkAdditionalFiltersMap) {
                const filters = window.prkAdditionalFiltersMap[filterCode];
                for (let i = 0; i < filters.length; i++) {
                    filters[i].checked = false;
                }
            }
        }

        // Remove selected quick link
        $('.js-selected-quick-link').remove();
    }
}

function updateUrl() {
    const newUrl = getFilterUrl(window.prkSelectedFilters);

    history.pushState('', '', newUrl);
}

function prepareFilterUrl(newFilter) {
    let isFound = false;
    const filters = [];
    window.prkSelectedFilters.forEach(function (filter) {
        if (filter.code === newFilter.code) {
            // Remove filter if already checked
            if (newFilter.checked) {
                newFilter.values = filter.values.filter(e => e !== newFilter.value);
                newFilter.viewValues = filter.viewValues.filter(e => e !== newFilter.title);
                newFilter.seoValues = filter.seoValues.filter(e => e !== newFilter.seoValue);
            } else {
                newFilter.values = arrayUnique([...filter.values, newFilter.value]);
                newFilter.viewValues = arrayUnique([...filter.viewValues, newFilter.title]);
                newFilter.seoValues = arrayUnique([...filter.seoValues, newFilter.seoValue]);
            }
            filters.push(newFilter);
            isFound = true;
        } else {
            filters.push(filter);
        }
    });

    if (!isFound) {
        newFilter.values = [newFilter.value];
        newFilter.viewValues = [newFilter.title];
        newFilter.seoValues = [newFilter.seoValue];
        filters.push(newFilter);
    }

    return getFilterUrl(filters);
}

function getFilterUrl(selectedFilters) {
    // URL: section path + SEO filters
    const sectionPathParts = location.pathname.split('/').filter(pathPart => pathPart && pathPart.indexOf(MAIN_SEPARATOR) === -1);
    const seoFilters = selectedFilters.filter(filter => filter.seoCode).sort((a, b) => (a.seoCode > b.seoCode) ? 1 : -1);
    const seoFilterPathParts = seoFilters.map(filter => getSeoFilterPath(filter));

    const newUrlPath = '/' + [...sectionPathParts, ...seoFilterPathParts].join('/') + '/';

    // Add query param filters
    const queryParams = new URLQueryParams(location.search);
    const queryParamFilters = selectedFilters.filter(filter => !filter.seoCode);
    const queryParamFilterParts = queryParamFilters.map(filter => filter.code + FILTER_PARAM_VALUE_CONNECTOR + filter.values.join('__'));
    const filtersQueryParamValue = queryParamFilterParts.join(FILTER_PARAM_SEPARATOR);

    if (filtersQueryParamValue)
        queryParams.set(FILTER_PARAM_NAME, filtersQueryParamValue);
    else
        queryParams.delete(FILTER_PARAM_NAME);

    // When changing filter, page count can change, so go to the first page
    queryParams.delete('page');

    // Filter out utm to not mess with marketing
    queryParams.delete('utm_source');
    queryParams.delete('utm_medium');
    queryParams.delete('utm_campaign');
    queryParams.delete('utm_term');
    queryParams.delete('utm_content');

    return newUrlPath + (queryParams.length ? `?${queryParams}` : '') + (location.hash ? location.hash : '');
}

function getSeoFilterPath(filter) {
    if (filter.seoCode && filter.seoValues) {
        filter.seoValues.sort();
        return filter.seoCode + MAIN_SEPARATOR + filter.seoValues.join(VALUES_SEPARATOR);
    } else {
        return '';
    }
}

function updateResultProductList() {
    let loaderBlock = $('body');
    showLoader(loaderBlock);
    fetch(setUrlParameter(location.href,  'only_products' , 'true'), {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then(async response => {
            const data = await response.json();
            await loadJQuery();
            jQuery('.js-productsContainer').replaceWith($(data.html));

            // Update filter count labels
            const filtersMap = data.filters;
            $('.js-termsFilter').forEach(function(termsFilter) {
                const $termsFilter = $(termsFilter);
                const filterCode = $termsFilter.data('code');
                // Skip just changed filter
                if (filterCode === window.prkLastChangedFilterCode) {
                    return;
                }

                const filterValuesMap = filtersMap[filterCode] || {};
                $termsFilter.find('.js-FilterCheckbox').forEach(function(filterCheckbox) {
                    const $filterCheckbox = $(filterCheckbox);
                    const filterCount = filterValuesMap[$filterCheckbox.find('input[type=checkbox]').data('seo-value')] || 0;
                    if (filterCount === 0) {
                        $filterCheckbox.addClass('inactive');
                    } else {
                        $filterCheckbox.removeClass('inactive');
                    }
                    $filterCheckbox.find('.count').html(filterCount);
                });
            });
            // Update prkAdditionalFiltersMap
            for (const filterCode in filtersMap) {
                // Skip just changed filter
                if (filterCode === window.prkLastChangedFilterCode) {
                    continue;
                }

                const filterValuesMap = filtersMap[filterCode] || {};
                if (filterCode in window.prkAdditionalFiltersMap) {
                    let filters = window.prkAdditionalFiltersMap[filterCode];
                    for (let i = 0; i < filters.length; i++) {
                        if (filters[i].seoValue in filterValuesMap) {
                            filters[i].filteredCount = filterValuesMap[filters[i].seoValue];
                        }
                    }
                }
            }

            // Update SEO section name
            let resultQuantity = Number(data.result_quantity);
            if (resultQuantity > 0) {
                switch (window.poryadokPageType) {
                    case 'brands':
                        const totalCountElement = document.querySelector('.js-brand-products-total-count');
                        if (totalCountElement)
                            totalCountElement.innerText = data.total_count;
                        break;

                    case 'catalog_lvl_2+':
                    case 'search_results':
                        const $h1 = $('h1');

                        if ($h1.length) {
                            const currentH1 = $h1.text();
                            // We should have only one h1 on the page
                            $h1.html(data.seo_section_name);
                            // Update product count
                            $h1.siblings('.product-count').html(data.total_count_declension);
                            // Remove additional breadcrumb if presented
                            const $breadcrumbs = $('li.bx-breadcrumb-item');
                            if (currentH1 !== data.seo_section_name && $breadcrumbs.length === 6) {
                                $breadcrumbs.last().remove();
                            }
                        }
                        break;
                    case 'gifts':
                        $('.js-gifts-catalog-title').text(data.seo_section_name);
                        break;
                }

                document.dispatchEvent(new Event('catalogupdate'));
            }

            hideLoader(loaderBlock);
            // Add result count notification in snackbar
            Snackbar.show({
                showAction: false,
                text: `<div class="snackbar-body">Подходящих товаров: <b>${resultQuantity}</b></div>`,
                pos: 'top-center',
                duration: 2000,
                customClass: 'catalog-filter-snackbar'
            });
        })
        .catch(reason => {
            hideLoader(loaderBlock);
            logError(reason);
        });
}

/**
 * Updates query string using js
 * @param {MouseEvent|PointerEvent|TouchEvent} event
 * @return {void}
 */
function changeQueryStringHandler(event) {
    event.preventDefault();
    const target = this;

    const queryParams = new URLQueryParams(window.location.search);

    // Get current params and params to update, then filter out empty strings
    const paramsToUpdate = new URLQueryParams(target.dataset.queryStringParams || '');

    // And update query params in hash with new ones
    for (const {key, value} of paramsToUpdate.entries()) {
        queryParams.set(key, value);
    }

    // Reload page
    window.location.search = `?${queryParams}`;
}

/**
 * @return {string}
 */
function getUrlForFullFilter() {
    var url = $('.js-urlWithFilterBySections').val();
    url = url + '&' + 'search-filter[price]=' + $('.js-filterMin').val() + ',' + $('.js-filterMax').val();

    return url;
}

/**
 * @param {Dom7} filterBlock
 * @return {void}
 */
function showResultsQuantityForFilter(filterBlock) {
    const filterUrl = getUrlForFullFilter(),
          data = new FormData();

    data.append('FILTER_URL', filterUrl);
    data.append('ajax', 'Y');

    history.pushState('', '', filterUrl);

    fetch(location.href, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: data,
    })
        .then(response => response.json())
        .then(data => {
            var resultQuantity = Number(data.result_quantity);
            filterBlock.find('.js-filterResultQuantityValue').text(resultQuantity);
            filterBlock.parents('form').find('.buttons span.js-filterResultQuantityValue').text('(' + resultQuantity + ')');
            filterBlock.find('.js-filterResultQuantityBlock').fadeIn('fast');

            if (resultQuantity < 1) {
                $('.js-setFilters, .js-filterResultQuantityBlock')
                    .addClass('inaccessible')
                    .addClass('js-inaccessible');
            } else {
                $('.js-setFilters, .js-filterResultQuantityBlock')
                    .removeClass('inaccessible')
                    .removeClass('js-inaccessible');
            }
        })
        .catch(logError);
}